import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '../material.module';

import { DynamicFormDialogComponent } from './dynamic-form-dialog/dynamic-form-dialog.component';
import { DynamicFormQuestionComponent } from './dynamic-form-question/dynamic-form-question.component';
import { QuestionControlService } from './shared/question-control.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule
  ],
  declarations: [
    DynamicFormQuestionComponent,
    DynamicFormDialogComponent
  ],
  exports: [
    DynamicFormDialogComponent
  ],
  providers: [
    QuestionControlService
  ],
  entryComponents: [
    DynamicFormDialogComponent
  ]
})
export class DynamicFormModule { }



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/dynamic-form/dynamic-form.module.ts